/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamQuestion } from './oralExamQuestion';
import type { ReferringResource } from './referringResource';

export interface ScheduledQuestion {
  question: OralExamQuestion;
  alternatives?: OralExamQuestion[];
  referringResources?: ReferringResource[];
}
